<div class="copilot" data-element="copilot-window" *ngIf="this.contentVisible">
  <dx-scroll-view height="100%" [showScrollbar]="'onHover'" [useNative]="false">
    <div class="copilot-content" #scrollContent>

      <ets-apg-copilot-tab-bar
          [activeTab]="this.activeTab"
          [stale]="this.isStale"
          (tabChange)="this.onTabClick($event)"
          (reset)="this.onReset()"></ets-apg-copilot-tab-bar>

      <!-- Roll positions (runnable) -->
      <div class="tab-body" [class.ets-hidden]="this.activeTab !== 'rollPositions'">

        <ets-apg-copilot-breadcrumb-bar *ngIf="this.collapsed"
            [inputs]="this.rollInputs"
            [changedKeys]="this.paramChanges"
            (expand)="this.onBreadcrumbEdit()"></ets-apg-copilot-breadcrumb-bar>

        <!-- Kept alive (form state survives collapse); only hidden while collapsed. -->
        <ets-apg-roll-positions-panel
            [class.ets-hidden]="this.collapsed"
            [availableExpirations]="this.availableExpirations"
            [expirationsLoading]="this.expirationsLoading"
            [changedKeys]="this.paramChanges"
            [maxRangeDays]="this.maxRangeDays"
            [defaultWeekdayExclusions]="this.defaultWeekdayExclusions"
            [anchorKeyReader]="this.anchorKeyReader"
            (stateChange)="this.onRollState($event)"></ets-apg-roll-positions-panel>

        <div class="run-bar">
          <dx-button data-element="btn-run-copilot" text="Ask ORION" type="default"
                     [disabled]="!this.canRun" (onClick)="this.onRun()" width="100%"></dx-button>
        </div>

        <ets-apg-copilot-results-list
            [run]="this.activeRun"
            [suggestions]="this.activeSuggestions"
            [maxCards]="this.maxCards"
            (previewToggle)="this.onPreviewToggle($event)"
            (review)="this.onReview($event)"></ets-apg-copilot-results-list>
      </div>

      <!-- Zone (read-only: no run button, no inputs, no cards) -->
      <div class="tab-body" [class.ets-hidden]="this.activeTab !== 'zone'">
        <ets-apg-zone-panel [currentZone]="this.currentZone"></ets-apg-zone-panel>
      </div>

    </div>
  </dx-scroll-view>
</div>
